export const stream = (state) => {
  return state.stream;
};
